import weeklyQuestionSummaryService from '../services/WorkReport/weekly-question-summary-service';
import WorkReportConstants from '../constants/work-report-constants';
// import { message } from 'antd';

// const statusMap = ["未提交", "未回复", "已回复"];
// const dataMode = 1;


///Question summary

export function fetchQuestionSummaryList(gets, callback = null) {
	return dispatch => weeklyQuestionSummaryService.getQuestionList(gets, res => {
		//res.data.Data.forEach(data => data.status_name = statusMap[data.status]);
		dispatch({
			type: WorkReportConstants.ActionTypes.SELECTWEEKLYQUESTIONSUMMARYSUCCESS,
			payload: {
				data: res.data.Data
			}
		});
	}, err => dispatch({
			type: WorkReportConstants.ActionTypes.UPDATEWEEKLYQUESTIONSUMMARYSTATUSSUCCESS,
			payload: {
				status: "error"
			}
		})
	);
}
export function increaseQuestionSummaryLoadCounter() {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.INCREASEWEEKLYQUESTIONSUMMARYLOADCOUNTER,
	});
}
export function setWeeklyQuestionSummaryFilter(filters) {
	return dispatch => dispatch({
		type: WorkReportConstants.ActionTypes.SETWEEKLYQUESTIONSUMMARYFILTERS,
		payload: {
			filters: filters
		}
	});
}














// WEBPACK FOOTER //
// ./src/actions/weely-question-summary-actions.js